import { chakra } from '@plurall/elo-v3';

import { benchmarkingTabsRootRecipe } from './benchmarking-tabs.recipe';

export const BenchmarkingTabsRootFactory = chakra('div', benchmarkingTabsRootRecipe);
